// Generated by scripts/prep_sales_resources.py (iter114s.104).
// Thumbnails live in public/sales-resources/thumbs/; originals live in
// Emergent Object Storage, streamed via /api/sales-resources/file/...

export const SALES_RESOURCE_CATEGORIES = [
  {
    "name": "Sales Collateral",
    "slug": "sales-collateral",
    "description": "Ready-to-send flyers and one-pagers for pitching custom stickers, labels, decals and more.",
    "items": [
      {
        "title": "Ahead of the Class (Safer Schools)",
        "slug": "ahead-of-the-class-safer-schools",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/ahead-of-the-class-safer-schools.jpg",
        "file": "/api/sales-resources/file/sales-collateral/ahead-of-the-class-safer-schools.pdf"
      },
      {
        "title": "Clear Vinyl Stickers Promotional Flyer(CDN)",
        "slug": "clear-vinyl-stickers-promotional-flyer-cdn",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/clear-vinyl-stickers-promotional-flyer-cdn.jpg",
        "file": "/api/sales-resources/file/sales-collateral/clear-vinyl-stickers-promotional-flyer-cdn.pdf"
      },
      {
        "title": "Custom Die-Cut Vinyl Stickers(CDN)",
        "slug": "custom-die-cut-vinyl-stickers-cdn",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/custom-die-cut-vinyl-stickers-cdn.jpg",
        "file": "/api/sales-resources/file/sales-collateral/custom-die-cut-vinyl-stickers-cdn.pdf"
      },
      {
        "title": "Custom Floor Decals -Big Messages Start Here(CDN)",
        "slug": "custom-floor-decals-big-messages-start-here-cdn",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/custom-floor-decals-big-messages-start-here-cdn.jpg",
        "file": "/api/sales-resources/file/sales-collateral/custom-floor-decals-big-messages-start-here-cdn.pdf"
      },
      {
        "title": "Custom Magnets That Stick Everywhere(USD)",
        "slug": "custom-magnets-that-stick-everywhere-usd",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/custom-magnets-that-stick-everywhere-usd.jpg",
        "file": "/api/sales-resources/file/sales-collateral/custom-magnets-that-stick-everywhere-usd.pdf"
      },
      {
        "title": "Custom Patches for Every Journey",
        "slug": "custom-patches-for-every-journey",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/custom-patches-for-every-journey.jpg",
        "file": "/api/sales-resources/file/sales-collateral/custom-patches-for-every-journey.pdf"
      },
      {
        "title": "Custom Patches, Bigger Stories",
        "slug": "custom-patches-bigger-stories",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/custom-patches-bigger-stories.jpg",
        "file": "/api/sales-resources/file/sales-collateral/custom-patches-bigger-stories.pdf"
      },
      {
        "title": "Festive Custom Gift Box Promotions",
        "slug": "festive-custom-gift-box-promotions",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/festive-custom-gift-box-promotions.jpg",
        "file": "/api/sales-resources/file/sales-collateral/festive-custom-gift-box-promotions.pdf"
      },
      {
        "title": "Food & Beverage Branding",
        "slug": "food-beverage-branding",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/food-beverage-branding.jpg",
        "file": "/api/sales-resources/file/sales-collateral/food-beverage-branding.pdf"
      },
      {
        "title": "Glitter Stickers That Shine(USD)",
        "slug": "glitter-stickers-that-shine-usd",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/glitter-stickers-that-shine-usd.jpg",
        "file": "/api/sales-resources/file/sales-collateral/glitter-stickers-that-shine-usd.pdf"
      },
      {
        "title": "Glossy Roll Labels Promotional Flyer(CDN)",
        "slug": "glossy-roll-labels-promotional-flyer-cdn",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/glossy-roll-labels-promotional-flyer-cdn.jpg",
        "file": "/api/sales-resources/file/sales-collateral/glossy-roll-labels-promotional-flyer-cdn.pdf"
      },
      {
        "title": "Glossy Roll Labels for Every Brand(USD)",
        "slug": "glossy-roll-labels-for-every-brand-usd",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/glossy-roll-labels-for-every-brand-usd.jpg",
        "file": "/api/sales-resources/file/sales-collateral/glossy-roll-labels-for-every-brand-usd.pdf"
      },
      {
        "title": "Holographic Sticker Promotions Flyer(USD)",
        "slug": "holographic-sticker-promotions-flyer-usd",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/holographic-sticker-promotions-flyer-usd.jpg",
        "file": "/api/sales-resources/file/sales-collateral/holographic-sticker-promotions-flyer-usd.pdf"
      },
      {
        "title": "Holographic Stickers That Shine",
        "slug": "holographic-stickers-that-shine",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/holographic-stickers-that-shine.jpg",
        "file": "/api/sales-resources/file/sales-collateral/holographic-stickers-that-shine.pdf"
      },
      {
        "title": "Holographic Stickers, Maximum Impact",
        "slug": "holographic-stickers-maximum-impact",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/holographic-stickers-maximum-impact.jpg",
        "file": "/api/sales-resources/file/sales-collateral/holographic-stickers-maximum-impact.pdf"
      },
      {
        "title": "Ideas That Connect",
        "slug": "ideas-that-connect",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/ideas-that-connect.jpg",
        "file": "/api/sales-resources/file/sales-collateral/ideas-that-connect.pdf"
      },
      {
        "title": "Kiss Cut Stickers Promotional Flyer(USD)",
        "slug": "kiss-cut-stickers-promotional-flyer-usd",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/kiss-cut-stickers-promotional-flyer-usd.jpg",
        "file": "/api/sales-resources/file/sales-collateral/kiss-cut-stickers-promotional-flyer-usd.pdf"
      },
      {
        "title": "Open Door Policies (Safer Spaces)",
        "slug": "open-door-policies-safer-spaces",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/open-door-policies-safer-spaces.jpg",
        "file": "/api/sales-resources/file/sales-collateral/open-door-policies-safer-spaces.pdf"
      },
      {
        "title": "Post-Vaccine Promotional Ideas",
        "slug": "post-vaccine-promotional-ideas",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/post-vaccine-promotional-ideas.jpg",
        "file": "/api/sales-resources/file/sales-collateral/post-vaccine-promotional-ideas.pdf"
      },
      {
        "title": "Promotional Products That Pop",
        "slug": "promotional-products-that-pop",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/promotional-products-that-pop.jpg",
        "file": "/api/sales-resources/file/sales-collateral/promotional-products-that-pop.pdf"
      },
      {
        "title": "Remote Possibilities (Connected Teams)",
        "slug": "remote-possibilities-connected-teams",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/remote-possibilities-connected-teams.jpg",
        "file": "/api/sales-resources/file/sales-collateral/remote-possibilities-connected-teams.pdf"
      },
      {
        "title": "Stand Out in Style",
        "slug": "stand-out-in-style",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/stand-out-in-style.jpg",
        "file": "/api/sales-resources/file/sales-collateral/stand-out-in-style.pdf"
      },
      {
        "title": "Standout Sticker and Print Solutions",
        "slug": "standout-sticker-and-print-solutions",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/standout-sticker-and-print-solutions.jpg",
        "file": "/api/sales-resources/file/sales-collateral/standout-sticker-and-print-solutions.pdf"
      },
      {
        "title": "Sticker Page Ideas",
        "slug": "sticker-page-ideas",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/sticker-page-ideas.jpg",
        "file": "/api/sales-resources/file/sales-collateral/sticker-page-ideas.pdf"
      },
      {
        "title": "Sticker Showcase",
        "slug": "sticker-showcase",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/sticker-showcase.jpg",
        "file": "/api/sales-resources/file/sales-collateral/sticker-showcase.pdf"
      },
      {
        "title": "Stickers With Shine",
        "slug": "stickers-with-shine",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/stickers-with-shine.jpg",
        "file": "/api/sales-resources/file/sales-collateral/stickers-with-shine.pdf"
      },
      {
        "title": "Stickier Brand Ideas",
        "slug": "stickier-brand-ideas",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/stickier-brand-ideas.jpg",
        "file": "/api/sales-resources/file/sales-collateral/stickier-brand-ideas.pdf"
      },
      {
        "title": "Together We Can Stop the Spread",
        "slug": "together-we-can-stop-the-spread",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/together-we-can-stop-the-spread.jpg",
        "file": "/api/sales-resources/file/sales-collateral/together-we-can-stop-the-spread.pdf"
      },
      {
        "title": "Vehicle Rental Branding Solutions",
        "slug": "vehicle-rental-branding-solutions",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/vehicle-rental-branding-solutions.jpg",
        "file": "/api/sales-resources/file/sales-collateral/vehicle-rental-branding-solutions.pdf"
      },
      {
        "title": "White Vinyl Decals Promotional Flyer(USD)",
        "slug": "white-vinyl-decals-promotional-flyer-usd",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/sales-collateral/white-vinyl-decals-promotional-flyer-usd.jpg",
        "file": "/api/sales-resources/file/sales-collateral/white-vinyl-decals-promotional-flyer-usd.pdf"
      }
    ]
  },
  {
    "name": "Branding Highlights",
    "slug": "branding-highlights",
    "description": "Monthly and seasonal branding highlight sheets showcasing fresh product ideas.",
    "items": [
      {
        "title": "April Branding Highlights",
        "slug": "april-branding-highlights",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/branding-highlights/april-branding-highlights.jpg",
        "file": "/api/sales-resources/file/branding-highlights/april-branding-highlights.pdf"
      },
      {
        "title": "February Branding Highlights",
        "slug": "february-branding-highlights",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/branding-highlights/february-branding-highlights.jpg",
        "file": "/api/sales-resources/file/branding-highlights/february-branding-highlights.pdf"
      },
      {
        "title": "March Branding Highlights",
        "slug": "march-branding-highlights",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/branding-highlights/march-branding-highlights.jpg",
        "file": "/api/sales-resources/file/branding-highlights/march-branding-highlights.pdf"
      },
      {
        "title": "November Branding Highlights",
        "slug": "november-branding-highlights",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/branding-highlights/november-branding-highlights.jpg",
        "file": "/api/sales-resources/file/branding-highlights/november-branding-highlights.pdf"
      },
      {
        "title": "October Branding Highlights",
        "slug": "october-branding-highlights",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/branding-highlights/october-branding-highlights.jpg",
        "file": "/api/sales-resources/file/branding-highlights/october-branding-highlights.pdf"
      },
      {
        "title": "September Branding Highlights",
        "slug": "september-branding-highlights",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/branding-highlights/september-branding-highlights.jpg",
        "file": "/api/sales-resources/file/branding-highlights/september-branding-highlights.pdf"
      },
      {
        "title": "Spring Branding Highlights",
        "slug": "spring-branding-highlights",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/branding-highlights/spring-branding-highlights.jpg",
        "file": "/api/sales-resources/file/branding-highlights/spring-branding-highlights.pdf"
      }
    ]
  },
  {
    "name": "Catalog Download",
    "slug": "catalog-download",
    "description": "The full EG3 product catalog in email-friendly and print-ready editions.",
    "items": [
      {
        "title": "EG3 Catalog-Email",
        "slug": "eg3-catalog-email",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/catalog-download/eg3-catalog-email.jpg",
        "file": "/api/sales-resources/file/catalog-download/eg3-catalog-email.pdf"
      },
      {
        "title": "EG3 Catalog-Print",
        "slug": "eg3-catalog-print",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/catalog-download/eg3-catalog-print.jpg",
        "file": "/api/sales-resources/file/catalog-download/eg3-catalog-print.pdf"
      }
    ]
  },
  {
    "name": "Application Instructions",
    "slug": "application-instructions",
    "description": "Step-by-step application guides for decals, transfers, tattoos and more.",
    "items": [
      {
        "title": "Clear Decal Wet Application Guide",
        "slug": "clear-decal-wet-application-guide",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/application-instructions/clear-decal-wet-application-guide.jpg",
        "file": "/api/sales-resources/file/application-instructions/clear-decal-wet-application-guide.pdf"
      },
      {
        "title": "Iron-On Transfer Application Guide",
        "slug": "iron-on-transfer-application-guide",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/application-instructions/iron-on-transfer-application-guide.jpg",
        "file": "/api/sales-resources/file/application-instructions/iron-on-transfer-application-guide.pdf"
      },
      {
        "title": "Temporary Tattoo Application Guide",
        "slug": "temporary-tattoo-application-guide",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/application-instructions/temporary-tattoo-application-guide.jpg",
        "file": "/api/sales-resources/file/application-instructions/temporary-tattoo-application-guide.pdf"
      },
      {
        "title": "Transfer Sticker Application Guide",
        "slug": "transfer-sticker-application-guide",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/application-instructions/transfer-sticker-application-guide.jpg",
        "file": "/api/sales-resources/file/application-instructions/transfer-sticker-application-guide.pdf"
      },
      {
        "title": "Wall Decal Application Guide",
        "slug": "wall-decal-application-guide",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/application-instructions/wall-decal-application-guide.jpg",
        "file": "/api/sales-resources/file/application-instructions/wall-decal-application-guide.pdf"
      },
      {
        "title": "Window Decal Application Guide",
        "slug": "window-decal-application-guide",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/application-instructions/window-decal-application-guide.jpg",
        "file": "/api/sales-resources/file/application-instructions/window-decal-application-guide.pdf"
      }
    ]
  },
  {
    "name": "Video Tutorials",
    "slug": "video-tutorials",
    "description": "Watch-and-learn application videos for every decal and transfer product.",
    "items": [
      {
        "title": "How do I apply my Iron-On Labels and Transfers",
        "slug": "how-do-i-apply-my-iron-on-labels-and-transfers",
        "type": "video",
        "thumb": "/sales-resources/thumbs/video-tutorials/how-do-i-apply-my-iron-on-labels-and-transfers.jpg",
        "file": "/api/sales-resources/file/video-tutorials/how-do-i-apply-my-iron-on-labels-and-transfers.mp4"
      },
      {
        "title": "How do I apply my temporary tattoos",
        "slug": "how-do-i-apply-my-temporary-tattoos",
        "type": "video",
        "thumb": "/sales-resources/thumbs/video-tutorials/how-do-i-apply-my-temporary-tattoos.jpg",
        "file": "/api/sales-resources/file/video-tutorials/how-do-i-apply-my-temporary-tattoos.mp4"
      },
      {
        "title": "How to Apply Your Vinyl Lettering and Numbering",
        "slug": "how-to-apply-your-vinyl-lettering-and-numbering",
        "type": "video",
        "thumb": "/sales-resources/thumbs/video-tutorials/how-to-apply-your-vinyl-lettering-and-numbering.jpg",
        "file": "/api/sales-resources/file/video-tutorials/how-to-apply-your-vinyl-lettering-and-numbering.mp4"
      },
      {
        "title": "How to apply your Clear Decal",
        "slug": "how-to-apply-your-clear-decal",
        "type": "video",
        "thumb": "/sales-resources/thumbs/video-tutorials/how-to-apply-your-clear-decal.jpg",
        "file": "/api/sales-resources/file/video-tutorials/how-to-apply-your-clear-decal.mp4"
      },
      {
        "title": "How to apply your Custom Floor Decal",
        "slug": "how-to-apply-your-custom-floor-decal",
        "type": "video",
        "thumb": "/sales-resources/thumbs/video-tutorials/how-to-apply-your-custom-floor-decal.jpg",
        "file": "/api/sales-resources/file/video-tutorials/how-to-apply-your-custom-floor-decal.mp4"
      },
      {
        "title": "How to apply your Custom Street Decal",
        "slug": "how-to-apply-your-custom-street-decal",
        "type": "video",
        "thumb": "/sales-resources/thumbs/video-tutorials/how-to-apply-your-custom-street-decal.jpg",
        "file": "/api/sales-resources/file/video-tutorials/how-to-apply-your-custom-street-decal.mp4"
      },
      {
        "title": "How to apply your Custom Vinyl Window Decal",
        "slug": "how-to-apply-your-custom-vinyl-window-decal",
        "type": "video",
        "thumb": "/sales-resources/thumbs/video-tutorials/how-to-apply-your-custom-vinyl-window-decal.jpg",
        "file": "/api/sales-resources/file/video-tutorials/how-to-apply-your-custom-vinyl-window-decal.mp4"
      },
      {
        "title": "How to apply your Custom Wall Decal",
        "slug": "how-to-apply-your-custom-wall-decal",
        "type": "video",
        "thumb": "/sales-resources/thumbs/video-tutorials/how-to-apply-your-custom-wall-decal.jpg",
        "file": "/api/sales-resources/file/video-tutorials/how-to-apply-your-custom-wall-decal.mp4"
      },
      {
        "title": "How to apply your Signature or Monogram Wall Decal",
        "slug": "how-to-apply-your-signature-or-monogram-wall-decal",
        "type": "video",
        "thumb": "/sales-resources/thumbs/video-tutorials/how-to-apply-your-signature-or-monogram-wall-decal.jpg",
        "file": "/api/sales-resources/file/video-tutorials/how-to-apply-your-signature-or-monogram-wall-decal.mp4"
      }
    ]
  },
  {
    "name": "Additional Resources",
    "slug": "additional-resources",
    "description": "Product guides, infographics, webinar decks and idea books for deeper dives.",
    "items": [
      {
        "title": "2026 Self Promo Trends Guide",
        "slug": "2026-self-promo-trends-guide",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/2026-self-promo-trends-guide.jpg",
        "file": "/api/sales-resources/file/additional-resources/2026-self-promo-trends-guide.pdf"
      },
      {
        "title": "Adhesive Alternatives (Creative Ways to Stick)",
        "slug": "adhesive-alternatives-creative-ways-to-stick",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/adhesive-alternatives-creative-ways-to-stick.jpg",
        "file": "/api/sales-resources/file/additional-resources/adhesive-alternatives-creative-ways-to-stick.pdf"
      },
      {
        "title": "Adhesive Alternatives Promotional Infographic",
        "slug": "adhesive-alternatives-promotional-infographic",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/adhesive-alternatives-promotional-infographic.jpg",
        "file": "/api/sales-resources/file/additional-resources/adhesive-alternatives-promotional-infographic.pdf"
      },
      {
        "title": "Bold Decal Promotions Infographic",
        "slug": "bold-decal-promotions-infographic",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/bold-decal-promotions-infographic.jpg",
        "file": "/api/sales-resources/file/additional-resources/bold-decal-promotions-infographic.pdf"
      },
      {
        "title": "Colourful Clings Promotional Infographic",
        "slug": "colourful-clings-promotional-infographic",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/colourful-clings-promotional-infographic.jpg",
        "file": "/api/sales-resources/file/additional-resources/colourful-clings-promotional-infographic.pdf"
      },
      {
        "title": "Colourful DTF Transfer Promotional Flyer",
        "slug": "colourful-dtf-transfer-promotional-flyer",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/colourful-dtf-transfer-promotional-flyer.jpg",
        "file": "/api/sales-resources/file/additional-resources/colourful-dtf-transfer-promotional-flyer.pdf"
      },
      {
        "title": "Custom Decals for Every Surface",
        "slug": "custom-decals-for-every-surface",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/custom-decals-for-every-surface.jpg",
        "file": "/api/sales-resources/file/additional-resources/custom-decals-for-every-surface.pdf"
      },
      {
        "title": "Custom Decals, Bold Impressions",
        "slug": "custom-decals-bold-impressions",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/custom-decals-bold-impressions.jpg",
        "file": "/api/sales-resources/file/additional-resources/custom-decals-bold-impressions.pdf"
      },
      {
        "title": "Custom Labels for Every Idea",
        "slug": "custom-labels-for-every-idea",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/custom-labels-for-every-idea.jpg",
        "file": "/api/sales-resources/file/additional-resources/custom-labels-for-every-idea.pdf"
      },
      {
        "title": "Custom Patches Promotional Infographic",
        "slug": "custom-patches-promotional-infographic",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/custom-patches-promotional-infographic.jpg",
        "file": "/api/sales-resources/file/additional-resources/custom-patches-promotional-infographic.pdf"
      },
      {
        "title": "Custom Pouches (Flexible Packaging Solutions)",
        "slug": "custom-pouches-flexible-packaging-solutions",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/custom-pouches-flexible-packaging-solutions.jpg",
        "file": "/api/sales-resources/file/additional-resources/custom-pouches-flexible-packaging-solutions.pdf"
      },
      {
        "title": "Custom Pouches, Limitless Possibilities",
        "slug": "custom-pouches-limitless-possibilities",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/custom-pouches-limitless-possibilities.jpg",
        "file": "/api/sales-resources/file/additional-resources/custom-pouches-limitless-possibilities.pdf"
      },
      {
        "title": "Custom Sticker Pages, Endless Possibilities",
        "slug": "custom-sticker-pages-endless-possibilities",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/custom-sticker-pages-endless-possibilities.jpg",
        "file": "/api/sales-resources/file/additional-resources/custom-sticker-pages-endless-possibilities.pdf"
      },
      {
        "title": "Custom Stickers & Labels Guide",
        "slug": "custom-stickers-labels-guide",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/custom-stickers-labels-guide.jpg",
        "file": "/api/sales-resources/file/additional-resources/custom-stickers-labels-guide.pdf"
      },
      {
        "title": "Die-Cut Stickers That Impress",
        "slug": "die-cut-stickers-that-impress",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/die-cut-stickers-that-impress.jpg",
        "file": "/api/sales-resources/file/additional-resources/die-cut-stickers-that-impress.pdf"
      },
      {
        "title": "EG3 Promotions (Ideas That Stick)",
        "slug": "eg3-promotions-ideas-that-stick",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/eg3-promotions-ideas-that-stick.jpg",
        "file": "/api/sales-resources/file/additional-resources/eg3-promotions-ideas-that-stick.pdf"
      },
      {
        "title": "Getting Back to Business Safely",
        "slug": "getting-back-to-business-safely",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/getting-back-to-business-safely.jpg",
        "file": "/api/sales-resources/file/additional-resources/getting-back-to-business-safely.pdf"
      },
      {
        "title": "Hang Tag Stickers (Small Detail, Big Impact)",
        "slug": "hang-tag-stickers-small-detail-big-impact",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/hang-tag-stickers-small-detail-big-impact.jpg",
        "file": "/api/sales-resources/file/additional-resources/hang-tag-stickers-small-detail-big-impact.pdf"
      },
      {
        "title": "Image Transfer Decals Marketing Flyer",
        "slug": "image-transfer-decals-marketing-flyer",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/image-transfer-decals-marketing-flyer.jpg",
        "file": "/api/sales-resources/file/additional-resources/image-transfer-decals-marketing-flyer.pdf"
      },
      {
        "title": "Innovation in Every Impression",
        "slug": "innovation-in-every-impression",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/innovation-in-every-impression.jpg",
        "file": "/api/sales-resources/file/additional-resources/innovation-in-every-impression.pdf"
      },
      {
        "title": "Iron-On Transfers (Ideas You Can Wear)",
        "slug": "iron-on-transfers-ideas-you-can-wear",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/iron-on-transfers-ideas-you-can-wear.jpg",
        "file": "/api/sales-resources/file/additional-resources/iron-on-transfers-ideas-you-can-wear.pdf"
      },
      {
        "title": "Kiss-Cut Sticker Materials Guide",
        "slug": "kiss-cut-sticker-materials-guide",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/kiss-cut-sticker-materials-guide.jpg",
        "file": "/api/sales-resources/file/additional-resources/kiss-cut-sticker-materials-guide.pdf"
      },
      {
        "title": "Kiss-Cut Stickers, Made Simple",
        "slug": "kiss-cut-stickers-made-simple",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/kiss-cut-stickers-made-simple.jpg",
        "file": "/api/sales-resources/file/additional-resources/kiss-cut-stickers-made-simple.pdf"
      },
      {
        "title": "Premium Die-Cut Sticker Materials",
        "slug": "premium-die-cut-sticker-materials",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/premium-die-cut-sticker-materials.jpg",
        "file": "/api/sales-resources/file/additional-resources/premium-die-cut-sticker-materials.pdf"
      },
      {
        "title": "Product Education Webinar Promo",
        "slug": "product-education-webinar-promo",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/product-education-webinar-promo.jpg",
        "file": "/api/sales-resources/file/additional-resources/product-education-webinar-promo.pdf"
      },
      {
        "title": "Product Overview",
        "slug": "product-overview",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/product-overview.jpg",
        "file": "/api/sales-resources/file/additional-resources/product-overview.pdf"
      },
      {
        "title": "Product Webinar Slides",
        "slug": "product-webinar-slides",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/product-webinar-slides.jpg",
        "file": "/api/sales-resources/file/additional-resources/product-webinar-slides.pdf"
      },
      {
        "title": "Rolls That Make Brands Shine",
        "slug": "rolls-that-make-brands-shine",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/rolls-that-make-brands-shine.jpg",
        "file": "/api/sales-resources/file/additional-resources/rolls-that-make-brands-shine.pdf"
      },
      {
        "title": "Self Promo Trends",
        "slug": "self-promo-trends",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/self-promo-trends.jpg",
        "file": "/api/sales-resources/file/additional-resources/self-promo-trends.pdf"
      },
      {
        "title": "Sticker & Label Formats Guide",
        "slug": "sticker-label-formats-guide",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/sticker-label-formats-guide.jpg",
        "file": "/api/sales-resources/file/additional-resources/sticker-label-formats-guide.pdf"
      },
      {
        "title": "Sticker Page Materials",
        "slug": "sticker-page-materials",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/sticker-page-materials.jpg",
        "file": "/api/sales-resources/file/additional-resources/sticker-page-materials.pdf"
      },
      {
        "title": "Sticker Page Showcase",
        "slug": "sticker-page-showcase",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/sticker-page-showcase.jpg",
        "file": "/api/sales-resources/file/additional-resources/sticker-page-showcase.pdf"
      },
      {
        "title": "Sticker Rolls (Branding Made Easy)",
        "slug": "sticker-rolls-branding-made-easy",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/sticker-rolls-branding-made-easy.jpg",
        "file": "/api/sales-resources/file/additional-resources/sticker-rolls-branding-made-easy.pdf"
      },
      {
        "title": "Technology First",
        "slug": "technology-first",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/technology-first.jpg",
        "file": "/api/sales-resources/file/additional-resources/technology-first.pdf"
      },
      {
        "title": "Temporary Tattoos (Fun, Custom, Colourful)",
        "slug": "temporary-tattoos-fun-custom-colourful",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/temporary-tattoos-fun-custom-colourful.jpg",
        "file": "/api/sales-resources/file/additional-resources/temporary-tattoos-fun-custom-colourful.pdf"
      },
      {
        "title": "Wear Your Brand with Pride",
        "slug": "wear-your-brand-with-pride",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/wear-your-brand-with-pride.jpg",
        "file": "/api/sales-resources/file/additional-resources/wear-your-brand-with-pride.pdf"
      },
      {
        "title": "Webinar Welcome",
        "slug": "webinar-welcome",
        "type": "pdf",
        "thumb": "/sales-resources/thumbs/additional-resources/webinar-welcome.jpg",
        "file": "/api/sales-resources/file/additional-resources/webinar-welcome.pdf"
      }
    ]
  }
];
